import api from '../../plugins/api';

// ÐÑÐ°Ð¹Ñ Ð¼Ð°ÑÐºÐ¸ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ. ÐÐ´Ð¸Ð½ Ð¿ÑÐ°Ð¹Ñ Ð½Ð° Ð¼Ð°ÑÐºÑ, Ð²ÑÐµÐ³Ð´Ð° Ð¾ÑÐºÑÑÑ Ð½Ð° ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ â
// Ð²ÐµÑÑÐ¸Ð¹ Ð¸ ÐºÐ¾Ð¿Ð¸Ð¹ Ð½ÐµÑ. Ð¡ÐµÐ¼Ð°Ð½ÑÐ¸ÐºÐ° Ð¿ÑÐ°Ð²Ð¸Ð» Ð¸ ÐºÐ¾ÑÐ·Ð¸Ð½ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ: doscar_back/docs/price-lists.md

// ÐÐ°ÑÐºÐ¸, Ñ ÐºÐ¾ÑÐ¾ÑÑÑ ÐµÑÑÑ ÑÑÐ¾Ðº Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ, â Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ñ Ð¿Ð¾ Ð¿ÑÐ°Ð¹ÑÐ°Ð¼
export const getPriceMarks = () => api.get('/api/crm/prices/marks');

// ÐÑÑ, ÑÑÐ¾ Ð½ÑÐ¶Ð½Ð¾ ÑÐºÑÐ°Ð½Ñ ÑÐ°Ð·Ð¾Ð¼: ÑÐ°Ð¿ÐºÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°, Ð¿ÑÐ°Ð²Ð¸Ð»Ð°, Ð²ÐµÑÐºÐ¸ ÑÑÐ¾ÐºÐ°, ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸
export const getPriceList = (markId) => api.get(`/api/crm/prices/${markId}`);

export const savePriceMeta = (markId, meta) => api.post(`/api/crm/prices/${markId}/meta`, meta);

// ÐÑÐ°Ð²Ð¸Ð»Ð° ÑÑÐ¾Ð´ÑÑ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼: ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð´ÐµÑÐµÐ²Ð° Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ðµ, ÑÐºÑÐ°Ð½ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ Ð¸ÑÐ¾Ð³Ð¾Ð²ÑÐ¹ Ð½Ð°Ð±Ð¾Ñ
export const savePriceRules = (markId, rules) => api.post(`/api/crm/prices/${markId}/rules`, rules);

// preview=true â Ð¿Ð¾ÑÑÐ¸ÑÐ°ÑÑ Ð¸ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¼ÐµÐ½ÑÑÑ
export const applyPriceList = (markId, preview) =>
  api.post(`/api/crm/prices/${markId}/apply?preview=${preview ? 'true' : 'false'}`);

export const rollbackPriceList = (batchId) => api.post(`/api/crm/prices/rollback/${batchId}`);

export const getPriceHistory = (markId) => api.get(`/api/crm/prices/${markId}/history`);
